import React, { Component } from 'react';
import { withRouter } from '../../utils/withRouter';
import withStyles from '@mui/styles/withStyles';
import FooterItem from './FooterItem';
import { items } from './footerConstants';
import GatedComponent from '../GatedComponent';

class Footer extends Component {
    state = {
        activeItem: undefined
    };

    static getDerivedStateFromProps(props, oldState) {
        const path = props.location.pathname;
        const activeItem = items.find(item => path === item.path);
        if (activeItem !== oldState.activeItem) {
            return { activeItem };
        }
        return null;
    }

    render() {
        return <div className="footer">{items.map(this.renderItem)}</div>;
    }

    renderItem = item => {
        const { activeItem } = this.state;
        return (
            <GatedComponent key={item.id || item.label} canViewCode={item.permission}>
                {() => {
                    return (
                        <FooterItem
                            key={item.label}
                            item={item}
                            active={item === activeItem}
                            onClick={e => this.onClickItem(e, item)}
                        />);
                }}
            </GatedComponent>
        );
    };

    onClickItem = (e, item) => {
        e.preventDefault();
        const { history } = this.props;
        history.push(item.path);
    };
}

export default withStyles({})(withRouter(Footer));
